module.exports = __webpack_public_path__ + "static/media/icon_no_material_402x.a96e040d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_no_material_402x.png
// module id = 349
// module chunks = 0